import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SqlTypeCopySource } from './sql-type.copysource';
import { SqlPoolTableDataset } from 'app/model/dataset/sql-pool-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';


@Metamodel.model({
    name: adfModelTypeMap.sqlPool.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(SqlPoolTableDataset) }
})
export class SqlPoolCopySource extends SqlTypeCopySource {
    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;
}
